module.exports = __webpack_public_path__ + "img/img01.a2ad19c4.png";